<template>
  <div>
    <div class="flex items-center bottom_line">
      <p class="col-12 col-md-8 py-4">
        Choose whether to add a satisfaction survey in some or all emails and
        define your organization’s feedback scale. Preset list is editable to
        suit your organization choice of scale and words.
      </p>
      <p class="col-12 col-md-4 flex justify-end">
        <button @click="$router.push('/settings/messaging/survey')" class="px-3 py-2 bg-primary-yellow rounded">
          Satisfaction Survey
        </button>
      </p>
    </div>

    <p class="py-3 pb-5">
        Feedback Scale
    </p>

    <div class="flex col-12 col-md-7 p-0 flex-wrap justify-between items-center">
        <div class="col-12 col-sm-5 col-md-4 p-0">
           <p class="font-semibold">Default Reply Email</p>
        </div>
        <div class="w-4"></div>
        <div class="col-12 col-sm-5 col-md-4 p-0">
           <p class="font-semibold">Email Mask</p>
        </div>
        <div class="col-12 col-sm-5 col-md-4 p-0 mt-4">
            <el-select></el-select>
         </div>
         <div class="w-4"></div>
         <div class="col-12 col-sm-5 col-md-4 p-0 mt-4">
            <p>enquiries.kashkap@optima.com</p>
         </div>
    </div>


    <table class="w-full mt-5">
        <thead>
            <td>Rating</td>
            <td>Description</td>
            <td>Emoticon</td>
            <td>Actions</td>
        </thead>
        <tbody>
           <tr v-for="i in [1,2,3,4,5,6]" :key="i">
            <td>{{i}}</td>
            <td>Very Dissatisfied</td>
            <td>Emoticon</td>
            <td>
                <button class="text-primary-green mr-4" @click="$router.push('/settings/messaging/survey')">Edit</button>
                <button class="text-red-500">Delete</button>
            </td>
           </tr>
        </tbody>
    </table>

    <div class="py-3">
        <button class="px-3 py-2 bg-primary-yellow rounded">Add New</button>
        <button class="ml-5">10 Max, 5 Left</button>
    </div>
    <hr/>

    <div class="py-3 flex justify-end">
        <button class="px-3 py-2 bg-gray-400 rounded">Back</button>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
 .bottom_line{
    border-bottom: 1px solid rgb(198, 183, 183);
 }
 tr{
    border-bottom: 1px solid grey;
 }
 tr:nth-last-child(1){
    border-bottom: 1px solid transparent;
 }
</style>
